import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { handleErrors, RefreshWindow, ShowErrorNotification } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { MARKETPLACE_ERROR_HANDLERS } from '../marketplace-error-handlers';
import { MSG_CANCEL_SUBSCRIPTION_DEFAULT, MSG_CANCEL_SUBSCRIPTION_OUTDATED_CANCEL_PARAMS } from '../notification-messages';
import { CancelSubscriptionParameters } from './model/cancel-subscription-parameters';

@Injectable({
  providedIn: 'root'
})
export class CancelSubscriptionService {
  constructor(private http: HttpClient) {}

  cancelSubscription(params: CancelSubscriptionParameters): Observable<unknown> {
    return this.http.post<void>(PLATFORM_ENVIRONMENT.apiUrl + '/subscription/cancel', params).pipe(
      handleErrors(MARKETPLACE_ERROR_HANDLERS, {
        OUTDATED_CANCEL_PARAMS: new RefreshWindow(MSG_CANCEL_SUBSCRIPTION_OUTDATED_CANCEL_PARAMS),
        DEFAULT: new ShowErrorNotification(MSG_CANCEL_SUBSCRIPTION_DEFAULT)
      })
    );
  }
}
